import { css } from '@microsoft/fast-element';
import { MainStyles } from '../../../../../main/main.styles';

export const DrilldownImpliedCarbonGraphStyles = css`
  ${MainStyles}

  .graph-div {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .title-menu {
    height: 60px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 8px;
  }

  .graph-title {
    font-size: 12px;
    font-family: 'Roboto-Bold', 'Roboto Bold', 'Roboto', sans-serif;
    font-weight: 700;
  }

  .criteria-selection {
    padding-bottom: 12px;
    display: flex;
    align-items: center;
  }

  .scenario-control {
    padding-left: 15px;
    display: flex;
    align-items: center;
    gap: 5px;
  }

  .outcome-control {
    padding-left: 15px;
    display: flex;
    align-items: center;
    gap: 5px;
  }

  .control-label {
    color: var(--gray-lighter);
    font-size: 13px;
    font-weight: 700;
  }

  .custom-segmented-item {
    margin: 0;
    height: 28px;
    padding: 5px;
  }
`;
